import React, { Fragment, useState } from "react";
import { connect } from "react-redux";

const BanUser = ({ setShowBanUser, bannedUser, Ban, profile_id }) => {
  const [formData, setFormData] = useState({
    text: "",
  });
  const [isCurrent, setCurrent] = useState({
    racism: false,
    inappropriate: false,
    spam: false,
    impersonation: false,
    threat: false,
    other: false,
  });

  const { text } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const maxLength = 100;

  return (
    <Fragment>
      <div className="report-overlay">
        <div className="report-container grey">
          <i
            className="fas fa-times fa-3x report-x"
            onClick={() => setShowBanUser({ submit: false, confirm: false })}
          ></i>
          <div className="report-user-header">
            <div className="report-user-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${bannedUser.avatar}`}
                alt="avatar"
                className="report-avi"
              />
            </div>
            <h1 className="report-title">Ban {bannedUser.channelid}</h1>
          </div>
          <div className="user-request-text white">
            Below is the user/message/post in which you are banning. Please also
            select a reason and provide context for banning this user:
          </div>
          {bannedUser.gif && bannedUser.gif !== "" && (
            <img
              src={bannedUser.gif}
              alt="media"
              className="reported-media-alt"
            />
          )}
          <div className="post-type-container">
            {bannedUser.text !== "" && (
              <div className="user-post-text white">{bannedUser.text}</div>
            )}
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (
                (formData.text !== "" && isCurrent.racism) ||
                isCurrent.inappropriate ||
                isCurrent.spam ||
                isCurrent.impersonation ||
                isCurrent.threat ||
                isCurrent.other
              ) {
                Ban(
                  bannedUser.channelid,
                  profile_id,
                  bannedUser.text,
                  isCurrent,
                  text,
                  bannedUser.video,
                  bannedUser.image,
                  bannedUser.gif,
                  bannedUser.message
                );
                setShowBanUser({ submit: false, confirm: true });
              }
            }}
          >
            <div className="report-choices">
              <input
                type="radio"
                checked={isCurrent.racism}
                value="racism"
                id="racism"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: e.target.checked,
                    inappropriate: false,
                    spam: false,
                    impersonation: false,
                    threat: false,
                    other: false,
                  })
                }
                name="racism"
              />
              <span className="option-background white mx-5">
                Racist or homophobic comment
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.inappropriate}
                value="inappropriate"
                id="inappropriate"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: e.target.checked,
                    spam: false,
                    impersonation: false,
                    threat: false,
                    other: false,
                  })
                }
                name="inappropriate"
              />
              <span className="option-background white mx-5">
                Indecent or inappropriate content
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.spam}
                value="spam"
                id="spam"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: e.target.checked,
                    impersonation: false,
                    threat: false,
                    other: false,
                  })
                }
                name="spam"
              />
              <span className="option-background white mx-5">Spam</span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.impersonation}
                value="impersonation"
                id="impersonation"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: false,
                    impersonation: e.target.checked,
                    threat: false,
                    other: false,
                  })
                }
                name="impersonation"
              />
              <span className="option-background white mx-5">
                False identity / fake account
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.threat}
                value="threat"
                id="threat"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: false,
                    impersonation: false,
                    threat: e.target.checked,
                    other: false,
                  })
                }
                name="threat"
              />
              <span className="option-background white mx-5">
                Threat made by this user
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.other}
                value="other"
                id="other"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: false,
                    impersonation: false,
                    threat: false,
                    other: e.target.checked,
                  })
                }
                name="other"
              />
              <span className="option-background white mx-5">Other</span>
              <br />
              <br />
            </div>
            <label htmlFor="email" className="report-user-input-label red">
              *Description:
            </label>
            <div className="report-input-hidden">
              <input
                className="report-user-input-alt"
                type="text"
                name="text"
                maxLength={100}
                placeholder="Enter Brief Description"
                onChange={(e) => onChange(e)}
              />
              <p className="white character-counter-comment">
                {text.split("").length}/{maxLength} characters
              </p>
            </div>
            <button
              className="report-button"
              onSubmit={(e) => {
                e.preventDefault();
                if (formData.text !== "" && isCurrent.racism) {
                  Ban(
                    bannedUser.channelid,
                    profile_id,
                    bannedUser.text,
                    isCurrent,
                    text,
                    bannedUser.video,
                    bannedUser.image,
                    bannedUser.gif,
                    bannedUser.message
                  );
                  setShowBanUser({ submit: false, confirm: true });
                } else if (formData.text !== "" && isCurrent.inappropriate) {
                  Ban(
                    bannedUser.channelid,
                    profile_id,
                    bannedUser.text,
                    isCurrent,
                    text,
                    bannedUser.video,
                    bannedUser.image,
                    bannedUser.gif,
                    bannedUser.message
                  );
                  setShowBanUser({ submit: false, confirm: true });
                } else if (formData.text !== "" && isCurrent.spam) {
                  Ban(
                    bannedUser.channelid,
                    profile_id,
                    bannedUser.text,
                    isCurrent,
                    text,
                    bannedUser.video,
                    bannedUser.image,
                    bannedUser.gif,
                    bannedUser.message
                  );
                  setShowBanUser({ submit: false, confirm: true });
                } else if (formData.text !== "" && isCurrent.impersonation) {
                  Ban(
                    bannedUser.channelid,
                    profile_id,
                    bannedUser.text,
                    isCurrent,
                    text,
                    bannedUser.video,
                    bannedUser.image,
                    bannedUser.gif,
                    bannedUser.message
                  );
                  setShowBanUser({ submit: false, confirm: true });
                } else if (formData.text !== "" && isCurrent.threat) {
                  Ban(
                    bannedUser.channelid,
                    profile_id,
                    bannedUser.text,
                    isCurrent,
                    text,
                    bannedUser.video,
                    bannedUser.image,
                    bannedUser.gif,
                    bannedUser.message
                  );
                  setShowBanUser({ submit: false, confirm: true });
                } else if (formData.text !== "" && isCurrent.other) {
                  Ban(
                    bannedUser.channelid,
                    profile_id,
                    bannedUser.text,
                    isCurrent,
                    text,
                    bannedUser.video,
                    bannedUser.image,
                    bannedUser.gif,
                    bannedUser.message
                  );
                  setShowBanUser({ submit: false, confirm: true });
                }
              }}
            >
              <i className="fas fa-ban mx-5"></i>Ban User
            </button>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {})(BanUser);
